/**
 * @param {string | undefined} [size]
 * @returns {React.ReactElement}
 */
const IconCookieShield = ({ size = '20%' }) => (
  <svg
    width={size}
    height={size}
    version="1.1"
    viewBox="0 0 1200 1200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#002867">
      <path d="m1162.8 908.4h-441.6c-2.3984 0-4.8008 2.3984-4.8008 4.8008v18c0 10.801-8.3984 20.398-20.398 20.398l-190.8 0.003906c-10.801 0-20.398-9.6016-20.398-20.398v-16.801c0-2.3984-2.3984-4.8008-4.8008-4.8008h-442.8c-3.6016 0-7.1992 3.6016-7.1992 7.1992v73.199c0 34.801 28.801 63.602 63.602 63.602h1012.8c34.801 0 63.602-28.801 63.602-63.602v-73.199c-0.003906-4.8008-3.6055-8.4023-7.2031-8.4023z" />
      <path d="m172.8 855.6h853.2c31.199 0 55.199-25.199 55.199-55.199v-530.4c0-67.199-55.199-122.4-122.4-122.4h-718.8c-67.199 0-122.4 55.199-122.4 122.4v529.2c0 31.199 25.199 56.402 55.199 56.402zm56.398-585.6c0-6 4.8008-10.801 10.801-10.801h720c6 0 10.801 4.8008 10.801 10.801v474h-741.6z" />
      <path d="m752.4 433.2-79.199 79.199c0 40.801-32.398 73.199-73.199 73.199l-46.801 46.801c14.398 2.3984 30 3.6016 46.801 3.6016 103.2 0 174-58.801 208.8-96 15.602-16.801 15.602-43.199 0-60-13.199-13.199-32.402-31.199-56.402-46.801z" />
      <path d="m780 324c-9.6016-9.6016-24-9.6016-33.602 0l-72 72c-22.801-6-48-10.801-74.398-10.801-103.2 0-174 58.801-208.8 96-15.602 16.801-15.602 43.199 0 60 16.801 18 43.199 42 78 61.199l-43.199 43.199c-9.6016 9.6016-9.6016 24 0 33.602 4.8008 4.8008 10.801 7.1992 16.801 7.1992s12-2.3984 16.801-7.1992l320.4-321.6c9.6016-9.6016 9.6016-24 0-33.602zm-248.4 216c-3.6016-8.3984-6-18-6-28.801 0-40.801 33.602-74.398 74.398-74.398 9.6016 0 19.199 2.3984 28.801 6z" />
    </g>
  </svg>
);

export default IconCookieShield;
